import React from "react";
import Disease from "./Disease";
import NoResults from "./NoResults";
import PropTypes from "prop-types";

const DiseaseList = (props) => {
  const results = props.results;

  if (!results) {
    return false;
  }

  // Filter by status
  const checkStatus = function (result) {
    var fundStatus = (result && result.Fund_Status ? result.Fund_Status : "").toLowerCase();

    switch (fundStatus) {
      case "open":
        return !!props.open;
      case "closed, wait list available":
        return !!props.closed;
      case "closed":
        return !!props.closed;
      case "wait list processing":
        return !!props.open;
      case "open to wait list only":
        return !!props.open;
      default:
        return true;
    }
  };

  // Base filtering by status
  var filteredFunds = results.filter(checkStatus);

  // Filter out items missing required link data (unless noLinks)
  // Require a name (wpTitle OR Fund_Name OR Disease) AND a permalink
  filteredFunds = filteredFunds.filter(function (fund) {
    if (props.noLinks) return true;
    var hasName =
      (fund && fund.wpTitle) ||
      (fund && fund.Fund_Name) ||
      (fund && fund.Disease);
    var hasPermalink = !!(fund && fund.permalink);
    return !!hasName && hasPermalink;
  });

  // Filter by first letter, if a letter is selected
  if (props.letter) {
    var target = String(props.letter).toUpperCase();
    filteredFunds = filteredFunds.filter(function (fund) {
      var nameSource =
        (fund && fund.wpTitle) ||
        (fund && fund.Fund_Name) ||
        (fund && fund.Disease) ||
        "";
      var first = String(nameSource)
        .trim()
        .charAt(0)
        .toUpperCase();
      return first === target;
    });
  }

  // Exclude inactive
  filteredFunds = filteredFunds.filter(function (f) {
    return !f || f.Fund_Status !== "Inactive" ? true : false;
  });

  // Sort flat by name (prefer wpTitle, then Fund_Name, then Disease)
  filteredFunds.sort(function (a, b) {
    var an = (
      (a && (a.wpTitle || a.Fund_Name || a.Disease)) || ""
    ).toLowerCase();
    var bn = (
      (b && (b.wpTitle || b.Fund_Name || b.Disease)) || ""
    ).toLowerCase();
    if (an > bn) return 1;
    if (an < bn) return -1;
    return 0;
  });

  var hasResults = filteredFunds.length > 0;

  if (!hasResults) {
    return (
      <NoResults message="Sorry, there are no disease funds associated with your search." />
    );
  }

  // FLAT RENDER (no letter headers)
  return (
    <table className="DiseaseTable disease-funds-table">
      <colgroup>
        <col className="col-name" />
        <col className="col-amount" />
        <col className="col-status" />
        <col className="col-nextstep" />
      </colgroup>

      <thead>
        <tr>
          <th scope="col">Fund name</th>
          <th scope="col"><span className="grant-amount-start">Initial grant </span>amount</th>
          <th scope="col">Status</th>
          <th scope="col">Next step</th>
        </tr>
      </thead>

      <tbody>
        {filteredFunds.map(function (result, idx) {
          var keyStr = (result && result.Id) ? result.Id : String(idx);
          return (
            <tr key={keyStr} className="Glossary-item">
              <Disease disease={result} displayStatus={props.displayStatus} />
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

DiseaseList.propTypes = {
  letter: PropTypes.string,
  open: PropTypes.bool,
  closed: PropTypes.bool,
  reEnrollment: PropTypes.bool,
  waitListOnly: PropTypes.bool,
  displayStatus: PropTypes.bool,
  results: PropTypes.array,
  noLinks: PropTypes.bool,
};

export default DiseaseList;
